import React from 'react';
import styled from 'styled-components';

const GallerySection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-light);
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  font-family: 'Libre Baskerville', serif;
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1.1rem;
  color: var(--text-dark);
  text-align: center;
  max-width: 600px;
  margin: 0 auto 3rem;
  line-height: 1.6;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const GalleryImage = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);

  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.03);
  }

  @media (max-width: 576px) {
    img {
      height: 250px;
    }
  }
`;

const Gallery = () => {
  return (
    <GallerySection>
      <SectionContainer>
        <SectionTitle>Our Office</SectionTitle>
        <SectionSubtitle>
          Step inside our modern, comfortable clinic designed with your care in mind.
        </SectionSubtitle>
        <GalleryGrid>
          <GalleryImage>
            <img src="/images/clinic-desk.jpg" alt="Welcoming reception area at Finch & Dudley Dental" loading="lazy" />
          </GalleryImage>
          <GalleryImage>
            <img src="/images/clinic-hallway.jpeg" alt="Modern hallway at Finch & Dudley Dental" loading="lazy" />
          </GalleryImage>
        </GalleryGrid>
      </SectionContainer>
    </GallerySection>
  );
};

export default Gallery;
